import React from "react"
import { connect } from "react-redux"
import { langSwap } from "../../actions/piano.js"
import { useTranslation } from "react-i18next";

function LanguageSwapButton(props) {
  const { t } = useTranslation();
  return (
    <ul className="language language--ja pc-only" onClick={() => {props.langSwap()}}>
      <li className={props.language === "ja_JP" ? "language__ja" : "language__en"}><a href="#" >{t("header.langJP")}</a></li>
      <li className="language__slash"> / </li>
      <li className={props.language === "en_US" ? "language__ja" : "language__en"}><a href="#" title="English">{t("header.langEN")}</a></li>
    </ul>
  )
}


const mapDispatchToProps = (dispatch) => ({
  langSwap: () => dispatch(langSwap()),
})

export default connect(null, mapDispatchToProps)(LanguageSwapButton)
